'use strict';

const _isString = require('lodash/isString');

/**
 * @function
 * @description extract the query string from URL
 * @param {String} url the url to extra query string from
 */
const getQueryString = (url) => {
    let qs;
    if (!_isString(url)) { return; }
    const a = document.createElement('a');
    a.href = url;
    if (a.search) {
        qs = a.search.substr(1); // remove the leading ?
    }
    return qs;
};

module.exports = getQueryString;
